import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SearchProductCTA from "../features/Products/SearchProductCTA";

const AppSearchProductCTA: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<SearchProductCTA />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppSearchProductCTA;
